 
  <template>
 <div class="row mx-0 bg-white ">
      <section class="login-form bg-light d-flex justify-content-center align-items-center col-md-6 col-xxs-12 h-100 min-vh-100 py-5">
        <b-card class="col-xl-7 col-10 login-form--card ">
          <LoginForm />
        <LoginByGoogle />
        </b-card>
      </section>
      <section itemscope itemtype="http://schema.org/RegisterAction" class="register-form d-block
       col-md-6 col-xxs-12 h-100 min-vh-100 d-flex justify-content-center align-items-center py-5">
        <b-card class="col-xl-7 col-10 register-form--card ">
          <div class="px-3">
            <span class="gift w-100 d-block">{{ $t('login.oneMonthGift') }}</span>
          </div>
          <RegisterForm />
        <RegisterByGoogle />
     <!--   <div class="d-flex justify-content-end px-5 d-xxs-none d-sm-flex d-md-none">
          <b-img :src="portalGeneralInfo.logoWithSubtitleUrl" class="m-5 portal-logo" />
     </div> -->
        </b-card>
      </section>
    </div>
    </template>

    <script>
  import LoginForm from '@/components/LoginForm.vue'
  import LoginByGoogle from '@/components/LoginByGoogle.vue'
  import RegisterForm from '@/components/RegisterForm.vue'
  import RegisterByGoogle from '@/components/RegisterByGoogle'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'LoginRegisterDesktop',
    components: {
      LoginForm,
      LoginByGoogle,
      RegisterForm,
      RegisterByGoogle
    },
    computed: {
      ...mapGetters({
        portalConfigurations: 'tenantDesign/config',
      }),
      portalGeneralInfo() {
        return this.portalConfigurations.general
      }
    },
  }
</script>
